import { useContext } from 'react'

// auth provider
import TokenContext, { TokenContextType } from '../contexts/TokenContext'

// ==============================|| AUTH HOOKS ||============================== //

const useAuth = (): TokenContextType => {
  const context = useContext(TokenContext)

  if (!context) throw new Error('context must be use inside provider')

  return context
}

export default useAuth
